import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'e5core-ui-categorization-bootstrap',
  templateUrl: './e5core-ui-categorization-bootstrap.component.html',
  styleUrls: ['./e5core-ui-categorization-bootstrap.component.css']
})
export class E5coreUiCategorizationBootstrapComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
